import { Box, Typography } from '@mui/material'
import UseTranslation from '../../hooks/UseTranslation'
import SvgIconSize from '../Cards/helpers/SvgIconSize'

const TitleWithCountV2 = ({
  store,
  title,
  withCount,
  icon,
  customStyle,
  customCount,
  customStore,
  iconColor,
  iconSize,
  textVariant,
  ...props
}) => {
  const { t } = UseTranslation()

  return (
    <Box sx={[styles.root, customStyle && customStyle]}>
      {icon && <SvgIconSize iconColor={iconColor} size={iconSize} icon={icon} />}
      <Typography variant={textVariant || 'h5'} sx={styles.titleContainer} {...props}>
        {title}
      </Typography>
      {withCount && (
      <Typography sx={styles.countContainer} variant="p">
        {t?.Showing}
        {' '}
        {customStore ?? store?.summaries?.all}
        {' '}
        {' '}
        {t?.Available}
        {' '}
        {customCount || title}
      </Typography>
      )}
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: { xs: 'none', sm: 'center' },
    marginBottom: { xs: '10px', sm: '30px' },
    flexDirection: 'row',
  },

  iconContainer: {
    marginRight: {
      xs: '5px', md: '7px', lg: '10px',
    },
    fontSize: 3,
    '& .material-icons': {
      overflow: 'unset',
      minWidth: 'min-content',
    },
  },
  iconAndTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    width: 'max-content',
    textTransform: 'capitalize',
    paddingBottom: {
      xs: '0px', md: '2px', lg: '0px',
    },
    paddingTop: { xs: '7px', sm: '0px' },
  },
  countContainer: {
    marginLeft: {
      xs: '30px', sm: '15px', md: '20px', lg: '27px',
    },
    fontSize: {
      xs: '12px', sm: '14px', md: '15px', lg: '18px',
    },
    marginTop: { xs: '3px', sm: '0px' },
    marginBottom: { xs: '0px', sm: '2px' },
    color: 'text.disabled',
    textTransform: 'capitalize',
    display: { xs: 'none', sm: 'flex' },
  },
}

export default TitleWithCountV2
